import React from 'react';
import { cn } from '@/lib/utils';

interface SidebarSkeletonProps {
  collapsed?: boolean;
  count?: number;
}

export function SidebarSkeleton({ collapsed = false, count = 5 }: SidebarSkeletonProps) {
  return (
    <div className="space-y-2">
      {Array.from({ length: count }).map((_, i) => (
        <div 
          key={i} 
          className={cn(
            "flex items-center rounded-lg px-3 py-2",
            collapsed ? "justify-center space-x-0 px-2" : "space-x-3"
          )}
        >
          <div className="h-5 w-5 bg-muted animate-pulse rounded" />
          {!collapsed && (
            <div className="h-4 bg-muted animate-pulse rounded flex-1" />
          )}
        </div>
      ))}
    </div>
  );
}
